<script>
  import {
    VContainer
  } from 'vuetify/lib'
  export default {
    name: 'wh-container',
    extends: VContainer
  };
</script>